/* eslint-disable @typescript-eslint/no-unused-vars */
import * as Types from '../../../../graphql/generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ICreateInternalRegulationObligationRuleControlMutationVariables = Types.Exact<{
  input: Types.ICreateInternalRegulationObligationRuleControlInput;
}>;

export type ICreateInternalRegulationObligationRuleControlMutation = {
  __typename?: 'Mutation';
  createInternalRegulationObligationRuleControl: {
    __typename: 'InternalRegulationObligationRuleControl';
    id: string;
    regulationObligationRuleId: string;
    controlId: string;
    isFromModel: boolean;
    control?: {
      __typename: 'InternalControl';
      id: string;
      code: string;
      latestName?: string | null;
      latestInstance?: {
        __typename: 'InternalControlInstance';
        id: string;
        controlId: string;
        name: string;
        descriptionReview?: string | null;
        descriptionIdentify?: string | null;
        descriptionAction?: string | null;
        objective?: string | null;
        type?: string | null;
        automation?: string | null;
      } | null;
    } | null;
  };
};

export const CreateInternalRegulationObligationRuleControlDocument = gql`
  mutation CreateInternalRegulationObligationRuleControl($input: CreateInternalRegulationObligationRuleControlInput!) {
    createInternalRegulationObligationRuleControl(input: $input) {
      __typename
      id
      regulationObligationRuleId
      controlId
      isFromModel
      control {
        __typename
        id
        code
        latestName
        latestInstance {
          __typename
          id
          controlId
          name
          descriptionReview
          descriptionIdentify
          descriptionAction
          objective
          type
          automation
        }
      }
    }
  }
`;
export type ICreateInternalRegulationObligationRuleControlMutationFn = Apollo.MutationFunction<
  ICreateInternalRegulationObligationRuleControlMutation,
  ICreateInternalRegulationObligationRuleControlMutationVariables
>;

/**
 * __useCreateInternalRegulationObligationRuleControlMutation__
 *
 * To run a mutation, you first call `useCreateInternalRegulationObligationRuleControlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInternalRegulationObligationRuleControlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInternalRegulationObligationRuleControlMutation, { data, loading, error }] = useCreateInternalRegulationObligationRuleControlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInternalRegulationObligationRuleControlMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ICreateInternalRegulationObligationRuleControlMutation,
    ICreateInternalRegulationObligationRuleControlMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ICreateInternalRegulationObligationRuleControlMutation,
    ICreateInternalRegulationObligationRuleControlMutationVariables
  >(CreateInternalRegulationObligationRuleControlDocument, options);
}
export type CreateInternalRegulationObligationRuleControlMutationHookResult = ReturnType<
  typeof useCreateInternalRegulationObligationRuleControlMutation
>;
export type CreateInternalRegulationObligationRuleControlMutationResult =
  Apollo.MutationResult<ICreateInternalRegulationObligationRuleControlMutation>;
export type CreateInternalRegulationObligationRuleControlMutationOptions = Apollo.BaseMutationOptions<
  ICreateInternalRegulationObligationRuleControlMutation,
  ICreateInternalRegulationObligationRuleControlMutationVariables
>;
